import { createContext } from 'react';

export const SchedulatorContext = createContext({});

export const BookingMode = createContext({});

export const UpdateCalContext = createContext({});